import { useState } from "react";
import { P } from "./styles/theme";
import { useAuth } from "./hooks/useAuth";

import LoginScreen       from "./components/LoginScreen";
import SanitationLog     from "./components/SanitationLog";
import ClientRecords     from "./components/ClientRecords";
import Bookings          from "./components/Bookings";
import CalendarView      from "./components/CalendarView";
import RevenueDashboard  from "./components/RevenueDashboard";
import ServiceBuilder    from "./components/ServiceBuilder";
import ShopSettings      from "./components/ShopSettings";
import InventoryManager  from "./components/InventoryManager";
import ErrorLogs         from "./components/ErrorLogs";
import TimeBlocks        from "./components/TimeBlocks";

const TABS = [
  { label: 'Sanitation',    icon: '🧴' },
  { label: 'Clients',       icon: '👤' },
  { label: 'Bookings',      icon: '📅' },
  { label: 'Calendar',      icon: '🗓️' },
  { label: 'Revenue',       icon: '💰' },
  { label: 'Services',      icon: '💅' },
  { label: 'Shop Settings', icon: '⚙️' },
  { label: 'Inventory',     icon: '📦' },
  { label: 'Time Blocks',   icon: '🚫' },
  { label: 'Error Logs',    icon: '🔍' },
];

const TAB_COMPONENTS = [
  SanitationLog, ClientRecords, Bookings, CalendarView,
  RevenueDashboard, ServiceBuilder, ShopSettings, InventoryManager, TimeBlocks, ErrorLogs,
];

export default function App() {
  const { session, isAdmin, authChecking, loginLoading, loginError, handleLogin, handleLogout } = useAuth();
  const [activeTab, setActiveTab] = useState(2);

  if (session === undefined || authChecking) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: P.bg, fontFamily: "'Nunito', sans-serif" }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '36px', marginBottom: '12px' }}>✦</div>
          <p style={{ color: P.muted, fontSize: '14px' }}>Loading...</p>
        </div>
      </div>
    );
  }

  if (!session) return <LoginScreen onLogin={handleLogin} loading={loginLoading} error={loginError} />;

  if (!isAdmin) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: P.bg, fontFamily: "'Nunito', sans-serif" }}>
        <div style={{ background: '#FDFAF8', borderRadius: '20px', padding: '40px 32px', maxWidth: '360px', width: '100%', textAlign: 'center', boxShadow: '0 8px 32px rgba(139,94,87,0.12)' }}>
          <p style={{ fontSize: '40px', marginBottom: '12px' }}>🔒</p>
          <h2 style={{ color: P.deep, marginBottom: '8px' }}>Access Denied</h2>
          <p style={{ color: P.muted, fontSize: '14px', marginBottom: '20px' }}>This app is for authorised staff only.<br />Logged in as: <strong>{session.user.email}</strong></p>
          <button onClick={handleLogout} style={{ width: '100%', padding: '12px', borderRadius: '10px', border: `1.5px solid ${P.border}`, background: '#fff', color: P.muted, cursor: 'pointer', fontWeight: 600 }}>Sign Out</button>
        </div>
      </div>
    );
  }

  const ActiveComponent = TAB_COMPONENTS[activeTab];

  return (
    <div style={{ fontFamily: "'Nunito', sans-serif", background: P.bg, minHeight: '100vh', color: P.text }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;600&family=Nunito:wght@400;600;700&display=swap'); * { box-sizing: border-box; margin: 0; padding: 0; }`}</style>
      <header style={{ background: `linear-gradient(135deg, ${P.rose}, ${P.deep})`, padding: '16px 16px 0', position: 'sticky', top: 0, zIndex: 100 }}>
        <div style={{ maxWidth: '720px', margin: '0 auto' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
            <h1 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '22px', color: '#FBF6F3', letterSpacing: '1px' }}>✦ Nails by Aurora Management</h1>
            <button onClick={handleLogout} style={{ background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff', fontSize: '12px', padding: '4px 12px', borderRadius: '6px', cursor: 'pointer' }}>Sign out</button>
          </div>
          <div style={{ display: 'flex', gap: '2px', overflowX: 'auto' }}>
            {TABS.map((tab, i) => (
              <button key={i} onClick={() => setActiveTab(i)}
                style={{ padding: '8px 10px', border: 'none', borderRadius: '8px 8px 0 0', background: activeTab === i ? P.bg : 'rgba(255,255,255,0.15)', color: activeTab === i ? P.deep : '#fff', fontWeight: 700, fontSize: '11px', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                {tab.icon} {tab.label}
              </button>
            ))}
          </div>
        </div>
      </header>
      <main style={{ padding: '20px 16px', maxWidth: '720px', margin: '0 auto' }}>
        <ActiveComponent />
      </main>
    </div>
  );
}
